import * as React from 'react'

import { Carousel } from 'react-responsive-carousel'
import { useRecoilValue } from 'recoil'

import { cld } from '../../../services/CloudinaryService'
import { translate } from '../../../state/locale/selectors/translate'
import { Link } from '../../reusable/Link'
import styles from './Sponsorship.module.scss'
import { ISponsorshipProps } from './Sponsorship.types'

export const Sponsorship = ({ data }: ISponsorshipProps) => {
  const i18n = useRecoilValue(translate).department

  return (
    <div className={styles.departmentWrapper}>
      {data?.elements?.map((section) => (
        <div className={styles.sectionWrapper} key={section.id}>
          {section.images?.length > 1 ? (
            <Carousel
              autoPlay={true}
              dynamicHeight={true}
              emulateTouch={true}
              infiniteLoop={true}
              interval={5000}
              showArrows={true}
              showIndicators={true}
              showStatus={false}
              showThumbs={false}
              swipeable={true}
              transitionTime={500}
              useKeyboardArrows={false}
              className={styles.carousel}
            >
              {section.images.map(({ provider_metadata, id }) => {
                const imageUrl = cld.image(provider_metadata.public_id).format('auto').quality('auto').toURL()

                return (
                  <div className={styles.imageContainer} key={id}>
                    <img className={styles.image} src={imageUrl} alt={section.title + id} />
                  </div>
                )
              })}
            </Carousel>
          ) : (
            <div className={styles.imageContainer} key={section.title}>
              <img
                className={styles.image}
                src={cld
                  .image(section.images[0]?.provider_metadata.public_id)
                  .format('auto')
                  .quality('auto')
                  .toURL()}
                alt={section.title}
              />
            </div>
          )}
          <h2 className={styles.sectionTitle}>{section.title}</h2>
          <p className={styles.paragraph}>{section.description}</p>
          {section.link && (
            <Link className={styles.buttonLink} to={section.link} blank={true}>
              {i18n.button}
            </Link>
          )}
          <div className={styles.separator} />
        </div>
      ))}
    </div>
  )
}
